/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 31.01.13, 14:15
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

export class GGSLineBreak {
    public static EXPLICIT: string = "explicit";
    public static TO_FIT: string = "toFit";
}
